import { render, staticRenderFns } from "./EmbroideryIncoming.vue?vue&type=template&id=35d35a78"
import script from "./EmbroideryIncoming.vue?vue&type=script&lang=js"
export * from "./EmbroideryIncoming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports